import { render, staticRenderFns } from "./WantListItemSearch.vue?vue&type=template&id=b0626d38&"
import script from "./WantListItemSearch.vue?vue&type=script&lang=js&"
export * from "./WantListItemSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports